import React from 'react';

interface ScrollableTrayContainerProps {
  children: React.ReactNode;
  className?: string;
  scrollableContainerRef?: React.MutableRefObject<HTMLDivElement>;
  marginTop?: number;
}

export const ScrollableTrayContainer = ({
  children, className, scrollableContainerRef, marginTop,
}: ScrollableTrayContainerProps): JSX.Element => (
  <div
    data-testid="scrollable-tray-container"
    data-cy="scrollable-tray-container"
    className={`relative w-full min-h-[60%] pb-24 h-fit p-5 bg-white shadow-t-sm rounded-t-3xl ${className}`}
    style={{ margin: `${marginTop}px 0 0` }}
    ref={scrollableContainerRef}
  >
    {children}
  </div>
);
